import type {ReactElement} from 'react';
import React from 'react';
import {useTimelineWidth} from '../../hooks/timeline-hooks';
import {TRACK_GAP} from '../../timeline.types';
import type {TimelineTrackProps} from './timeline-track.types';
import styles from './timeline-track.module.scss';

export function TimelineTrack({totalRows, trackHeight, children, trackRef}: TimelineTrackProps): ReactElement {
  const timelineWidth = useTimelineWidth();
  const height = totalRows * trackHeight + (totalRows - 1) * TRACK_GAP;

  const rowBackgrounds = Array.from({length: totalRows}, (_, index) => (
    <div
      key={`row-bg-${index}`}
      className={styles.rowBackground}
      style={{
        top: `${index * (trackHeight + TRACK_GAP)}px`,
        height: `${trackHeight}px`,
      }}
    />
  ));

  return (
    <div
      ref={trackRef}
      className={styles.track}
      style={{
        height: `${height}px`,
        width: `${timelineWidth}px`,
        minWidth: '100%',
      }}
    >
      {rowBackgrounds}
      {children}
    </div>
  );
}
